// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2RI5E","label":"Category_label__3G1Yf","content":"Category_content__3hQHT","header":"Category_header__1nXd1","location":"Category_location__3sp6C"};